// extracted by mini-css-extract-plugin
export default {"part1":"Usecase_part1__Dj0T7","part2":"Usecase_part2__e1whg"};